<template>
  <div
    :class="
      navigation || culturePop
        ? 'popup'
        : '' || startProjectPop || recruitPop
        ? 'popup black'
        : '' || awardsPop
        ? 'black-gra'
        : ''
    "
    class="container viewPage samsungFireView"
  >
    <header-area />

    <div class="worksView topPosition" :class="readyAction ? 'ready-action' : ''">
      <div class="contsBox">
        <div class="viewInCon">
          <div class="workTopTitle">
            <div class="workSlogan web">
              The complete mobile web process<br />to provide the seamless customer experience
            </div>
            <div class="workSlogan mobile">
              The complete mobile web<br />process to provide<br />the seamless<br />customer
              experience
            </div>
            <div class="workTopDay">
              <p>삼성화재 모바일 웹 완결형 프로세스 구축</p>
              <ul>
                <li>Mobile web</li>
                <li>2022.03.22</li>
              </ul>
            </div>
            <div class="workTopSns">
              <a href="https://m.samsungfire.com/" target="_blank" class="siteAddr"
                >https://m.samsungfire.com/</a
              >
              <ul>
                <li>
                  <social-sharing
                    url="https://www.pulip.com/sns/samsungfire"
                    title="모바일에서도 끊김없는 고객 경험"
                    hashtags="플립커뮤니케이션즈,삼성화재"
                    twitter-user="플립커뮤니케이션즈"
                    inline-template
                  >
                    <network network="facebook">
                      <a href="javascript:;" class="wFacebook">
                        <img src="@/assets/images/@sns_fb_w.png" alt="" />
                      </a>
                    </network>
                  </social-sharing>
                </li>
                <li>
                  <social-sharing
                    url="https://www.pulip.com/sns/samsungfire"
                    title="모바일에서도 끊김없는 고객 경험"
                    hashtags="플립커뮤니케이션즈,삼성화재"
                    twitter-user="플립커뮤니케이션즈"
                    inline-template
                  >
                    <network network="twitter">
                      <a href="javascript:;" class="wTweeter">
                        <img src="@/assets/images/@sns_tw_w.png" alt="" />
                      </a>
                    </network>
                  </social-sharing>
                </li>
                <li>
                  <a href="javascript:;" @click.prevent="doCopy" class="wChain">
                    <img src="@/assets/images/@web_link_w.png" alt="" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="workVisual">
        <div class="workImg">
          <span class="workMoveTxt">
            <marquee-text :duration="15"
              >&nbsp;The complete mobile web process to provide the seamless customer
              experience&nbsp;</marquee-text
            >
          </span>
          <img class="web" src="@/assets/images/works_view/ssFire/visual.jpg" alt="" />
          <img class="mobile" src="@/assets/images/works_view/ssFire/visual_m.jpg" alt="" />
        </div>
      </div>

      <div class="contsBox">
        <div class="topInfo">
          삼성화재는 대표 홈페이지 이용량이 증가함에 따라 비대면 서비스를 확대하고 보험금 청구 등
          고객 업무 처리 과정의 편의성을 개선해 디지털 경쟁력을 높이고자 했습니다.
          <br class="mobile" />이에 기존 삼성화재 앱에서만 구현되던 서비스를 모바일 웹에서도 이용할
          수 있도록 전환해 별도의 앱 설치 없이 모바일 웹에서 보험 업무 처리를 끝낼 수 있는 '모바일
          웹 완결형 프로세스'를 구축했습니다.
        </div>
      </div>
    </div>

    <kinesis-container event="scroll">
      <div class="wideConts">
        <div class="ssFireConcept topGoal">
          <div
            class="tit"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <strong>끊김없는</strong>
            <span>고객 경험 제공</span>
          </div>
          <div
            class="txtWrap"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <div class="smallTit">GOAL</div>
            <p class="txt">
              홈페이지에서 앱으로 이동해야 했던 단계를 없애고,<br />모바일 웹에서도 동일한 서비스를
              제공함으로써<br />끊김없는 고객 경험을 제공하고자 했습니다.
            </p>
          </div>
          <div
            class="roundBoxWrap"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <div class="roundLeft">
              <div class="roundLeft1">
                <div>Homepage</div>
              </div>
              <span></span>
              <div class="roundLeft2">
                <div>App</div>
              </div>
            </div>
            <div class="roundEqual">
              <span></span>
              <span></span>
            </div>
            <div class="roundRight">
              <div class="roundRight1">
                <div class="web">Mobile web</div>
                <div class="mobile">Mobile<br />web</div>
              </div>
              <div class="rightBg rightBg1"></div>
              <div class="rightBg rightBg2"></div>
              <div class="rightBg rightBg3"></div>
            </div>
          </div>
        </div>

        <div class="ssFireConcept type1">
          <div class="worksView">
            <div class="pointTxtWrap">
              <div class="point">Point 1</div>
              <div class="tit">APP-FREE</div>
              <div class="txt">
                삼성화재 앱을 별도로 설치해야만 이용할 수 있었던 보험금 청구, 계약 변경, 보험료
                납입, <br class="web" />보험계약대출, 장기보험 신용대출 등의 서비스를 모바일
                웹에서도 원스톱으로 처리할 수 있게 됐습니다.
              </div>
            </div>
            <div
              class="imgBox"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="imgDevice">
                <img src="@/assets/images/works_view/ssFire/device_point1.png" alt="" />
              </div>
              <div class="marquee-text-wrap">
                <div class="one">&nbsp; &nbsp; &nbsp; &nbsp; One</div>
                <div class="stop">&nbsp; &nbsp; &nbsp; &nbsp; stop</div>
              </div>
            </div>
          </div>
        </div>

        <div class="ssFireConcept type2">
          <div>
            <div class="pointTxtWrap">
              <div class="point">Point 2</div>
              <div class="tit">모바일에서도 간편한 보험 가입</div>
              <div class="txt">
                장기보험 가입 시 전자 서명이 가능해졌으며, <br class="mobile" />청약서 부본 및 약관,
                보험증권 등의 <br class="web" />서류를 <br class="mobile" />모바일 웹에서도 다운로드
                할 수 있습니다.
              </div>
            </div>
            <div
              class="iconBoxWrap"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="iconBox">
                <div class="icon">
                  <img src="@/assets/images/works_view/ssFire/icon_point2-1.svg" alt="" />
                </div>
                <p>보험증권</p>
              </div>
              <div class="iconBox">
                <div class="icon">
                  <img src="@/assets/images/works_view/ssFire/icon_point2-2.svg" alt="" />
                </div>
                <p>납입 증명서</p>
              </div>
              <div class="iconBox">
                <div class="icon">
                  <img src="@/assets/images/works_view/ssFire/icon_point2-3.svg" alt="" />
                </div>
                <p>가입 증명서</p>
              </div>
              <div class="iconBox">
                <div class="icon">
                  <img src="@/assets/images/works_view/ssFire/icon_point2-4.svg" alt="" />
                </div>
                <p>예상해지환급금 증명서</p>
              </div>
              <div class="iconBox">
                <div class="icon">
                  <img src="@/assets/images/works_view/ssFire/icon_point2-5.svg" alt="" />
                </div>
                <p>보험금지급 내역서</p>
              </div>
              <div class="iconBox">
                <div class="icon">
                  <img src="@/assets/images/works_view/ssFire/icon_point2-6.svg" alt="" />
                </div>
                <p>해지 영수증</p>
              </div>
              <div class="iconBox">
                <div class="icon">
                  <img src="@/assets/images/works_view/ssFire/icon_point2-7.svg" alt="" />
                </div>
                <p>손비처리 내역서</p>
              </div>
              <div class="iconBox">
                <div class="icon">
                  <img src="@/assets/images/works_view/ssFire/icon_point2-8.svg" alt="" />
                </div>
                <p>잔액재산 증명서</p>
              </div>
              <div class="iconBox">
                <div class="icon">
                  <img src="@/assets/images/works_view/ssFire/icon_point2-9.svg" alt="" />
                </div>
                <p>신용/담보대출 증명서</p>
              </div>
              <div class="iconBox">
                <div class="icon">
                  <img src="@/assets/images/works_view/ssFire/icon_point2-10.svg" alt="" />
                </div>
                <p>보험계약대출 증명서</p>
              </div>
            </div>
          </div>
        </div>

        <div class="ssFireConcept type3">
          <div class="worksView">
            <div class="pointTxtWrap">
              <div class="point">Point 3</div>
              <div class="tit">다양해진 인증 수단</div>
              <div class="txt">
                기존에 지원하던 공동인증서, 휴대폰 인증, 지문 인증 외에 금융인증서, 카카오페이 인증,
                <br class="web" />간편 비밀번호 인증을 추가 도입해 인증 수단을 확대했습니다.
              </div>
            </div>
            <div
              class="iconBoxWrap"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="iconBox">
                <div class="icon">
                  <img src="@/assets/images/works_view/ssFire/icon_point3-1.svg" alt="" />
                </div>
                <p>간편 비밀번호</p>
              </div>
              <div class="iconBox">
                <div class="icon">
                  <img src="@/assets/images/works_view/ssFire/icon_point3-2.svg" alt="" />
                </div>
                <p>금융인증서</p>
              </div>
              <div class="iconBox">
                <div class="icon">
                  <img src="@/assets/images/works_view/ssFire/icon_point3-3.svg" alt="" />
                </div>
                <p>카카오페이 인증</p>
              </div>
              <div class="iconBox">
                <div class="icon">
                  <img src="@/assets/images/works_view/ssFire/icon_point3-4.svg" alt="" />
                </div>
                <p>휴대폰 인증</p>
              </div>
            </div>
            <div class="deviceBg">
              <img src="@/assets/images/works_view/ssFire/device_point3.png" alt="" />
            </div>
            <div class="colorBg"></div>
          </div>
        </div>

        <div class="ssFireConcept type4">
          <div class="worksView">
            <div class="pointTxtWrap">
              <div class="point">Point 4</div>
              <div class="tit">회원가입부터<br />로그인까지 한 번에</div>
              <div class="txt">
                <span
                  >앱 실행을 포함해 11단계나 되었던 회원가입과 <br />로그인 절차를 6단계로
                  간소화했습니다.</span
                >
                특히 간편비밀번호를 등록하면 로그인은 물론이고 <br />대부분의 메뉴를 원스톱으로
                이용할 수 있어 <br />편의성을 대폭 강화했습니다.
              </div>
            </div>
            <div
              class="imgBox"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="imgDevice">
                <img src="@/assets/images/works_view/ssFire/device_point4.png" alt="" />
              </div>
              <div class="imgStepWrap">
                <div class="imgStep dot1"></div>
                <div class="imgStep dot2"></div>
                <div class="imgStep dot3"></div>
                <div class="imgStep dot4"></div>
                <div class="imgStep login"></div>
              </div>
              <div class="check">
                <svg
                  width="274"
                  height="274"
                  viewBox="0 0 274 274"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="137" cy="137" r="137" fill="#014BB4" />
                  <path
                    d="M76 145.4L117.796 183L199 91"
                    stroke="#014BB4"
                    stroke-width="20"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>

        <div class="ssFireConcept type5">
          <div class="worksView">
            <div class="pointTxtWrap">
              <div class="point">Point 5</div>
              <div class="tit">보기 쉽고, 쓰기 편한 홈페이지</div>
              <div class="txt">
                홈페이지를 직관적으로 사용할 수 있도록 화면 구조를 변경하고 <br class="web" />최신
                트렌드를 반영한 디자인 요소를 적용해 UI/UX를 개선했습니다.
              </div>
            </div>
            <div
              class="imgBox"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="imgDeviceWrap">
                <div class="imgDevice">
                  <img src="@/assets/images/works_view/ssFire/device_point5-1.png" alt="" />
                </div>
                <div class="imgDevice">
                  <img src="@/assets/images/works_view/ssFire/device_point5-2.png" alt="" />
                </div>
                <div class="imgDevice">
                  <img src="@/assets/images/works_view/ssFire/device_point5-3.png" alt="" />
                </div>
              </div>
              <div class="imgTxt">
                <p>
                  계약 내용 확인, 필요 서류 안내 등 텍스트가 많은 화면을 단순한 테이블 구조로
                  변경하고, <br class="web" />강조된 컬러의 플래그와 아이콘을 사용해 콘텐츠를 구분해
                  볼 수 있게 구성했습니다.
                </p>
                <p>
                  계약, 상품, 보상, 대출 화면에서는 주요 사용 메뉴를 <br class="web" />바로가기
                  링크로 제공해 관련 메뉴로 쉽게 이동할 수 있습니다.
                </p>
                <p>
                  복잡한데다 로딩 속도가 오래 걸렸던 마이 페이지는 계약 정보를 한눈에 파악하기
                  쉽도록 <br class="web" />박스로 구분하고 로딩이 오래 걸리는 데이터를 삭제해 처리
                  속도를 높였습니다.
                </p>
              </div>
            </div>
          </div>
          <div class="bgGradient"></div>
        </div>

        <div class="ssFireConcept type6">
          <div>
            <div class="pointTxtWrap">
              <div class="point">Point 6</div>
              <div class="tit">통합 플랫폼과 연계까지</div>
              <div class="txt">
                삼성금융네트웍스의 통합 금융 플랫폼인 모니모와의 <br class="mobile" />연계를 통해
                일관적인 고객 경험을 제공합니다.
              </div>
            </div>
            <div class="imgBox">
              <div
                class="imgWrap1"
                v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
              >
                <div class="ssWrap">
                  <div class="mnmLine web"></div>
                  <div class="ssLeft">
                    <div class="ssRound ss1">
                      <div>
                        <img src="@/assets/images/works_view/ssFire/ss1.png" alt="" />
                      </div>
                    </div>
                    <div class="ssRound ss2">
                      <div>
                        <img src="@/assets/images/works_view/ssFire/ss2.png" alt="" />
                      </div>
                    </div>
                  </div>
                  <div class="ssRight">
                    <div class="ssRound ss3">
                      <div>
                        <img src="@/assets/images/works_view/ssFire/ss3.png" alt="" />
                      </div>
                    </div>
                    <div class="ssRound ss4">
                      <div>
                        <img src="@/assets/images/works_view/ssFire/ss4.png" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mnmWrap">
                  <div class="mnm">
                    <img src="@/assets/images/works_view/ssFire/monimo.png" alt="" />
                  </div>
                  <div class="mnmBg mnmBg1"></div>
                  <div class="mnmBg mnmBg2"></div>
                  <div class="mnmBg mnmBg3"></div>
                </div>
              </div>
              <div
                class="imgWrap2"
                v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
              >
                <div class="imgDevice">
                  <div class="web">
                    <img src="@/assets/images/works_view/ssFire/device_point6.png" alt="" />
                  </div>
                  <div class="mobile">
                    <div>
                      <img src="@/assets/images/works_view/ssFire/device_point6-1_m.png" alt="" />
                    </div>
                    <div>
                      <img src="@/assets/images/works_view/ssFire/device_point6-2_m.png" alt="" />
                    </div>
                  </div>
                  <div class="menubar">
                    <div>
                      <img src="@/assets/images/works_view/ssFire/menubar.png" alt="" />
                    </div>
                  </div>
                </div>
                <div class="imgInfo">
                  <div class="info1">
                    <div>
                      <div class="tit">
                        찾기 쉬운 메뉴 구성
                      </div>
                      <p class="txt">
                        삼성화재 홈페이지에서 가장 많이 이용하는<br />14개의 주요 메뉴를 4개의
                        카테고리로<br />묶어 찾기 쉽게 구성했습니다.
                      </p>
                    </div>
                  </div>
                  <div class="info2">
                    <div>
                      <div class="tit">
                        한 눈에 보는 보험 현황
                      </div>
                      <p class="txt">
                        보험 가입 내용을 파악하기 쉽도록<br />내 보험 현황에 대한 요약 정보를
                        제공합니다.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </kinesis-container>

    <div class="worksView">
      <div class="contsBox">
        <div class="backToList">
          <router-link :to="{ name: 'works' }" class="backBtn">
            <img src="@/assets/images/@ico_back_x2.jpg" alt="" />
            <span>Back to list</span>
          </router-link>
        </div>
      </div>

      <router-link v-if="true" :to="{ name: 'works-samsungW' }" class="longEnd vType">
        <div class="viewType">
          <span>next</span>
          <strong class="web">삼성웰스토리 미디어 플랫폼 구축</strong>
          <strong class="mobile">삼성웰스토리<br />미디어 플랫폼 구축</strong>
        </div>

        <div class="engBg ssWellsEndBg">
          <span />
        </div>
      </router-link>
    </div>

    <footer-area />
  </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import Lottie from "vue-lottie";
import HeaderArea from "@/components/Header";
import FooterArea from "@/components/Footer";
import common from "@/shared/mixin/common.js";
import MarqueeText from "vue-marquee-text-component";
import VueKinesis from "vue-kinesis";
import { TweenLite } from "gsap/all";

Vue.use(VueKinesis);

export default {
  mixins: [common],
  name: "Main",
  /* head: {
      title: {
        inner: "삼성화재"
      }
    }, */
  head: {
    title: function() {
      return {
        inner: this.meta.title
      };
    },
    meta: function() {
      return [
        {
          name: "description",
          content: this.meta.desc
        },
        {
          name: "keywords",
          content: this.meta.keywords
        },
        // Open Graph
        { property: "og:title", content: this.meta.title },
        { property: "og:description", content: this.meta.desc },
        { property: "og:type", content: "website" },
        { property: "og:url", content: this.meta.url },
        { property: "og:image", content: this.meta.img },

        // Additional OG tags
        { property: "og:site_name", content: this.meta.siteName }
      ];
    }
  },
  components: {
    HeaderArea,
    FooterArea,
    MarqueeText,
    Lottie
  },
  data() {
    return {
      meta: {
        siteName: "삼성화재 모바일 웹 | 플립커뮤니케이션즈",
        title: "삼성화재 모바일 웹",
        desc:
          "삼성화재는 모바일 웹을 통해 보험 업무를 한번에 처리할 수 있는 완결형 프로세스를 구축하여 앱 설치 없이도 같은 서비스를 제공합니다. 보험금 청구, 계약 변경 등 주요 서비스를 모바일 웹에서도 이용 가능하게 하였고, 회원가입/로그인 절차를 대폭 간소화하였습니다. 또한 UI/UX를 개선하여 사용 편의성을 높였습니다.",
        keywords:
          "삼성화재, 모바일 웹, 보험금 청구, 보험료 납입, 보험계약대출, 장기보험, 전자 서명, 보험증권, 납입 증명서, 가입 증명서, 인증 수단, 회원가입, 로그인, UI/UX, 통합 플랫폼",
        url: "https://www.pulip.com/works/SamsungFire",
        img: "https://www.pulip.com/pulip-logo.jpg"
      },
      W: 0,
      icoInter: null,
      icoVal: 0
    };
  },
  computed: {
    ...mapState("common", {
      readyAction: state => state.readyAction,
      startProjectPop: state => state.startProjectPop,
      recruitPop: state => state.recruitPop,
      awardsPop: state => state.awardsPop,
      culturePop: state => state.culturePop,
      navigation: state => state.navigation
    }),
    W2() {
      return this.W / 2;
    },
    W3() {
      return this.W / 3;
    },
    W4() {
      return this.W / 4;
    }
  },
  methods: {
    // vuejs Bicint
    doCopy() {
      this.$copyText("https://www.pulip.com/sns/samsungfire").then(
        function(e) {
          alert("복사되었습니다.");
          console.log(e);
        },
        function(e) {
          console.log(e);
        }
      );
    },
    handleResize() {
      this.W = window.innerWidth;
      this.H = window.innerHeight;
    },
    visibilityChanged(isVisible, entry) {
      // this.isVisible = isVisible
      console.log(entry);
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    this.sec1Slider1.destroy();
    window.removeEventListener("resize", this.handleResize);
    clearInterval(this.icoInter);
  },
  mounted() {
    this.sec1Slider1 = new window.Swiper(".sec1Slider.swiper-container", {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      slidesPerView: "auto",
      centeredSlides: true,
      loop: true,
      spaceBetween: 30,
      speed: 1000,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false
      },
      breakpoints: {
        751: {
          spaceBetween: 130
        }
      }
    });
  }
};
</script>
